import React, { useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { useParams } from "react-router";

const SidebarEditStaff = ({ toggleEditSideBar, setToggleEditSideBar }) => {
  const { selectedStaff, selectedSidebarTab, setSelectedSidebarTab } =
    useGlobalContext();
  const navigate = useNavigate();
  const { id } = useParams();

  const handleLinkClick = (tab) => {
    // Set the selected sidebar tab
    setSelectedSidebarTab(tab);

    // Close sidebar on small screens
    if (window.innerWidth < 850) {
      // Remove the custom class
      setToggleEditSideBar(true);
    }
  };

  // Adjust sidebar visibility on resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 850) {
        setToggleEditSideBar(false); // Ensure sidebar is open on larger screens
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setToggleEditSideBar]);

  useEffect(() => {
    console.log("selectedStaff=====",selectedStaff)
    if (selectedStaff == null) {
      navigate("/staff-menu");
    }
  }, [selectedStaff]);
  return (
    <div
      className={`${
        toggleEditSideBar ? "-ml-[300px]" : "ml-[0px]"
      } editsidebar duration-300 ease-in-out edit-sidebar h-lvh shadow mt-[60px]  fixed top-[6px] bg-white p-[30px] pl-[5px] pr-[5px] overflow-scroll w-[300px] z-10 pb-10`}
    >
      <div className="flex flex-col sidelinks">
        <NavLink
          to={`/personal-detail/${id}`}
          className="flex justify-between items-center p-5 pb-5 font-medium text-[12px] whitespace-nowrap"
          onClick={() => {
            handleLinkClick("personal-details");
          }}
        >
          Personal Details <KeyboardArrowRightIcon className="arrow-icon" />
        </NavLink>
        <NavLink
          to={`/custom-detail/${id}`}
          className="flex justify-between items-center p-5 pb-5 font-medium text-[12px] whitespace-nowrap"
          onClick={() => {
            handleLinkClick("custom-details");
          }}
        >
          Custom Details <KeyboardArrowRightIcon />
        </NavLink>
        <NavLink
          to={`/background-verification/${id}`}
          className="flex justify-between items-center p-5 pb-5 font-medium text-[12px] whitespace-nowrap"
          onClick={() => {
            handleLinkClick("background-verification");
          }}
        >
          Background Verification <KeyboardArrowRightIcon />
        </NavLink>
        <NavLink
          to={`/employee-detail/${id}`}
          className="flex justify-between items-center p-5 pb-5 font-medium text-[12px] whitespace-nowrap"
          onClick={() => {
            handleLinkClick("employement-details");
          }}
        >
          Employment Details <KeyboardArrowRightIcon />
        </NavLink>
        <NavLink
          to={`/bank-detail/${id}`}
          className="flex justify-between items-center p-5 pb-5 font-medium text-[12px] whitespace-nowrap"
          onClick={() => {
            handleLinkClick("bank-account");
          }}
        >
          Bank Account <KeyboardArrowRightIcon />
        </NavLink>
        <NavLink
          to={`/user-permission/${id}`}
          className="flex justify-between items-center p-5 pb-5 font-medium text-[12px] whitespace-nowrap"
          onClick={() => {
            handleLinkClick("user-permissions");
          }}
        >
          User Permission <KeyboardArrowRightIcon />
        </NavLink>
        <NavLink
          to={`/attendance-detail/${id}`}
          className="flex justify-between items-center p-5 pb-5 font-medium text-[12px] whitespace-nowrap"
          onClick={() => {
            handleLinkClick("attendance-details");
          }}
        >
          Attendance Details 
          <KeyboardArrowRightIcon />
        </NavLink>
        <NavLink
          to={`/salary-details-edit/${id}`}
          className="flex justify-between items-center p-5 pb-5 font-medium text-[12px] whitespace-nowrap"
          onClick={() => {
            handleLinkClick("salary-details");
          }}
        >
          Salary Details <KeyboardArrowRightIcon />
        </NavLink>
        <NavLink
          to={`/leavepolicy-detail/${id}`}
          className="flex justify-between items-center p-5 pb-5 font-medium text-[12px] whitespace-nowrap"
          onClick={() => {
            handleLinkClick("leave&balancedetails");
          }}
        >
          Leave & Balance Details <KeyboardArrowRightIcon />
        </NavLink>
        <NavLink
          to={`/edit-penalty/${id}`}
          className="flex justify-between items-center p-5 pb-5 font-medium text-[12px] whitespace-nowrap"
          onClick={() => {
            handleLinkClick("penality-overtime");
          }}
        >
          Penalty & Overtime Details <KeyboardArrowRightIcon />
        </NavLink>
        <NavLink
          to={`/salary-overview/${id}`}
          className="flex justify-between items-center p-5 pb-5 font-medium text-[12px] whitespace-nowrap"
          onClick={() => {
            handleLinkClick("salary-overview");
          }}
        >
          Salary Overview
          <KeyboardArrowRightIcon />
        </NavLink>
        <NavLink
          to={`/documents`}
          className="flex justify-between items-center p-5 pb-10 font-medium text-[12px] whitespace-nowrap"
          onClick={() => {
            handleLinkClick("documents");
          }}
        >
          Documents
          <KeyboardArrowRightIcon />
        </NavLink>
        {/* <NavLink to="#" className='flex justify-between items-center p-5 pb-5 font-medium text-[12px] whitespace-nowrap'>Tax Declarations<KeyboardArrowRightIcon/></NavLink>  */}
        {/* <NavLink to="#" className='flex justify-between items-center p-5 pb-5 font-medium text-[12px] whitespace-nowrap'>Salary Details<KeyboardArrowRightIcon/></NavLink>  */}
      </div>
    </div>
  );
};

export default SidebarEditStaff;
